/**
 * Energy and emissions — demo L4076.
 */

import { groupNum } from '../../oem-engine.ts';
import { TOOLS, type EnergyGroupBy } from '../tools.ts';
import { cues, type IntentDef } from './types.ts';

export const energy: IntentDef = {
  id: 'energy',
  family: 'energy',
  priority: 58,
  examples: ['Compare emissions by drive type', "What is L-07's energy and emissions profile?"],
  score: cues({ any: [/energy|emission|co2|carbon|diesel|electric|battery|kwh|fuel burn|fuel use/], penalty: [[/battery (module|pack) .*(stock|store|order)/, 3]] }),
  async answer({ kit, E, L }) {
    const mid = E.machineFrom === 'text' ? E.machine : undefined;
    const g: EnergyGroupBy = /drive|battery|electric/.test(L)
      ? 'drive'
      : /class/.test(L)
        ? 'class'
        : mid
          ? 'machine'
          : 'mine';
    const e = await kit.run(TOOLS.energy_summary, { group_by: g, mine: E.mine ?? null });
    const markdown =
      `**Energy and emissions by ${g}** (12 days, 29 Aug – 9 Sep)\n\n` +
      `| ${g} | Machines | Diesel L | Electricity kWh | CO₂-e kg | kg CO₂-e / op h |\n|---|---|---|---|---|---|\n` +
      e.rows
        .filter((r) => !mid || r.group === mid)
        .map(
          (r) =>
            `| ${r.group} | ${r.machines} | ${groupNum(r.diesel_l)} | ${groupNum(r.kwh)} | ` +
            `${groupNum(r.co2_kg)} | ${r.kg_co2_per_op_hour} |`,
        )
        .join('\n') +
      `\n\nFactors: diesel 2.68 kg CO₂-e/L (scope 1); grid ${e.factors
        .map((f) => `${f.mine} ${f.grid_kgco2_per_kwh}`)
        .join(', ')} kg/kWh (scope 2). The battery-electric loaders (L-07, L-12) run at roughly 44 kg/h ` +
      `against ~78 kg/h for a diesel ML-21 on the same duty.`;
    if (mid) kit.focus({ machine: mid });
    return kit.done(markdown, ['energy_summary', 'shift_records', 'energy_factors']);
  },
};
